import { Link } from "react-router-dom";
import { ArrowLeft, CalendarClock, Vote, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Brand } from "@/components/Brand";

const CAMPAIGN_POSTER =
  "https://customer-assets-agu9un31.emergentagent.net/job_avvocato-turnos/artifacts/8so8plyv_WhatsApp%20Image%202026-09-20%20at%2013.27.34.jpeg";

export default function Elezioni() {
  return (
    <div className="min-h-screen bg-[#F6F1E7] grain-overlay">
      {/* Header */}
      <header className="sticky top-0 z-50 backdrop-blur-md bg-[#F4EFE4]/90 border-b border-amber-500/15">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to="/" aria-label="Torna alla home" data-testid="elezioni-home-logo"><Brand /></Link>
          <Link to="/" data-testid="elezioni-back-home" className="inline-flex items-center gap-2 text-stone-600 hover:text-amber-600 transition-colors text-sm">
            <ArrowLeft className="w-4 h-4" /> Torna al sito
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="text-center max-w-2xl mx-auto mb-12 animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#0b2a5b]/25 bg-[#0b2a5b]/5 px-4 py-1.5 mb-6">
            <Vote className="w-4 h-4 text-[#0b2a5b]" />
            <span className="text-xs uppercase tracking-[0.22em] text-[#0b2a5b] font-semibold">Elezioni Cassa Forense 2026-2030</span>
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-stone-900 font-semibold leading-[1.05] mb-5">
            Insieme per l'Avvocatura
          </h1>
          <p className="text-lg text-stone-600 leading-relaxed">
            L'Avv. <strong className="text-stone-900">Giuseppe Fera</strong> è candidato per l'elezione dei componenti
            del Comitato dei Delegati di Cassa Forense — Distretto di Napoli.
          </p>
        </div>

        {/* Poster */}
        <div className="card-luxe rounded-3xl overflow-hidden p-3 md:p-4 mb-12 animate-fade-up" data-testid="elezioni-poster-card">
          <img
            src={CAMPAIGN_POSTER}
            alt="Locandina campagna elettorale — Insieme per l'Avvocatura, Lista N.1 — Cassa Forense Distretto di Napoli 2026-2030"
            className="w-full h-auto rounded-2xl"
            data-testid="elezioni-poster-image"
          />
        </div>

        {/* Info */}
        <div className="grid md:grid-cols-2 gap-5 mb-12">
          <div className="card-luxe rounded-2xl p-7">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 rounded-lg border border-amber-500/25 bg-[#F4EFE4] flex items-center justify-center">
                <span className="font-serif text-xl text-amber-600">1</span>
              </div>
              <h2 className="font-serif text-xl text-stone-900">Scrivi Lista N. 1</h2>
            </div>
            <p className="text-sm text-stone-600 leading-relaxed">
              Sostieni la candidatura indicando la <strong className="text-stone-900">Lista N. 1 — Insieme per l'Avvocatura</strong> sulla scheda elettorale.
            </p>
          </div>
          <div className="card-luxe rounded-2xl p-7">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 rounded-lg border border-amber-500/25 bg-[#F4EFE4] flex items-center justify-center">
                <CalendarClock className="w-5 h-5 text-amber-600" />
              </div>
              <h2 className="font-serif text-xl text-stone-900">Quando si vota</h2>
            </div>
            <p className="text-sm text-stone-600 leading-relaxed">
              Le votazioni si terranno <strong className="text-stone-900">da lunedì 5 a venerdì 9 ottobre 2026</strong>.
            </p>
          </div>
        </div>

        <div className="text-center">
          <Link to="/">
            <Button className="bg-[#0b2a5b] hover:bg-[#0a2350] text-white font-semibold rounded-full px-8 h-12" data-testid="elezioni-cta-home">
              Scopri lo Studio Legale IusFera <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          </Link>
        </div>
      </main>

      <footer className="border-t border-amber-500/10 bg-[#F4EFE4]">
        <div className="py-6 text-center text-xs text-stone-500">
          © {new Date().getFullYear()} Studio Legale IusFera · Campagna elettorale Cassa Forense
        </div>
      </footer>
    </div>
  );
}
